import React from 'react';
import style from './style.module.scss';
import {Label as ProductLabel, renderLabelTooltip} from '../Label';
import {Typography} from 'components/Typography';
import {IProductSnippet, TProductLabel} from 'shared/types/productSnippet.types';

type TOnlineOnlyLabelProps = TProductLabel & Pick<IProductSnippet, 'id'>;

export const OnlineOnlyLabel = (props: TOnlineOnlyLabelProps) => {
    const {code, title, id, tooltip, url} = props;

    return (
        <ProductLabel className={style.main} key={code} id={id} url={url} tooltip={renderLabelTooltip(tooltip)}>
            <Typography variant={'label-12-r'}>{title}</Typography>
        </ProductLabel>
    );
};
